import { ReactElement } from 'react';
import { useRoutes, useAwsGetter } from '@localstack/services';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Button, Box, Typography } from '@mui/material';
import { Breadcrumbs, CognitoPoolDetails } from '@localstack/ui';

import { DEFAULT_COGNITO_ROUTES } from '@localstack/constants';

import { PoolNavTabs } from './components';

import { CognitoProps } from './types';

export const CognitoPool = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_COGNITO_ROUTES,
}: CognitoProps): ReactElement => {
  const { goto } = useRoutes();
  const { poolId } = useParams<'poolId'>();

  const { data: pool } = useAwsGetter('CognitoIdentityServiceProvider', 'describeUserPool', [{ UserPoolId: poolId }], {
    clientOverrides,
  });

  return (
    <Layout
      documentTitle="Pool Details"
      tabs={<PoolNavTabs poolId={poolId as string} routes={routes} />}
      title={
        <Box>
          <Typography variant="h4">Pool Details</Typography>
          <Breadcrumbs
            mappings={[
              ['Cognito', () => goto(routes.RESOURCES_COGNITO)],
              [pool?.UserPool?.Name ?? poolId, null],
            ]}
          />
        </Box>
      }
      actions={
        <>
          <Button variant="outlined" onClick={() => goto(routes.RESOURCES_COGNITO_USER_POOL_UPDATE, { poolId })}>
            Edit Pool
          </Button>
        </>
      }
    >
      <Card>
        <CardContent>
          <CognitoPoolDetails pool={pool?.UserPool} />
        </CardContent>
      </Card>
    </Layout>
  );
};
